import { stringify } from 'qs';
import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';
import { DefaultLayout } from '@layouts';
import { Hero, Services } from '@components';
const ServicesPage = ({ data }) => {
  const { seo, hero, services } = data;
  return (
    <>
      <NextSeo title={`Momento | ${seo?.metaTitle}`} />
      <DefaultLayout
        header={
          <Hero
            label={hero?.label}
            title={hero?.title}
            isHero
            description={hero?.description}
            hasSlider={hero?.media?.data?.length > 0}
            slides={hero?.media?.data.map(({ attributes }) => {
              return {
                img: attributes,
              };
            })}
          />
        }
      >
        <Services services={services?.data} />
      </DefaultLayout>
    </>
  );
};

export default ServicesPage;
export async function getServerSideProps({ params, locale }) {
  const path = process.env.NEXT_PUBLIC_STRAPI; // process.env.NEXT_PUBLIC_STRAPI;

  const qs = stringify(
    {
      populate: [
        'seo',
        'hero',
        'hero.media',
        'services',
        'services.img',
        'services.cta',
      ],
      locale: locale,
    },
    {
      encodeValuesOnly: true, // prettify URL
    },
  );
  const getProdData = await fetch(`${path}/services-page?${qs}`);
  const product = await getProdData.json();

  return {
    props: {
      data: product.data?.attributes,
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}
